import { ArticleHeading4, UIText1 } from '@cian/ui-kit';

import { HoveredLink } from '../HoveredLink';
import { Link } from '../Link';

import * as styles from './styles.css';

interface IAgentsOffersRowProps {
  fromAgentsPropsCountDisplay: string;
  fromAgentsPropsCountUrl: string;
}

export function AgentsOffersRow({ fromAgentsPropsCountDisplay, fromAgentsPropsCountUrl }: IAgentsOffersRowProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['agents-title']}>
        <HoveredLink url={fromAgentsPropsCountUrl} childNode={ArticleHeading4} as="h4" color="theme-dark">
          Предложения от агентов и собственников
        </HoveredLink>
      </div>
      <UIText1 color="text-main-default">
        <Link url={fromAgentsPropsCountUrl} target="_blank">
          {fromAgentsPropsCountDisplay}
        </Link>
      </UIText1>
    </div>
  );
}
